/*! *********************************************************************
 *
 * Copyright 2019 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************
 */

import React from 'react';
import {
  FileInput,
  FileField,
  TextInput,
  SaveButton,
  required,
  SelectInput,
} from 'react-admin';
import { Form } from 'react-final-form';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@material-ui/core';
import _map from 'lodash/map';

import {
  PREVIEW_ATTACHMENTS_TYPE,
  ASSET_TYPE_PREVIEW_TYPES,
  PREVIEW_TYPES,
} from '../models/asset';

const validateFile = [required()];
const validateLabel = [required()];

const PreviewDialog = (props) => {
  const handleClose = () => {
    props.close();
  };

  const handleClick = () => {
    document
      .querySelector('#preview-quick-create')
      .dispatchEvent(new Event('submit', { cancelable: true }));
  };

  const handleSubmit = (preview) => {
    if (props.record) {
      preview.id = props.record.id;
      preview.index = props.record.index;
    }

    preview.tags = PREVIEW_ATTACHMENTS_TYPE[preview.type].tags;

    if (!withCustomLabel(preview.type))
      preview.label = PREVIEW_ATTACHMENTS_TYPE[preview.type].label;

    preview.url = preview.file.url;

    props.onValidated(preview);
    handleClose();
  };

  const withCustomLabel = (type) =>
    type === PREVIEW_TYPES.PRESET || type === PREVIEW_TYPES.BACKPLATE;

  const previewTypes = ASSET_TYPE_PREVIEW_TYPES[props.assetType];

  return (
    <Dialog
      size="large"
      open={props.open}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">Add preview</DialogTitle>
      <DialogContent>
        <Form onSubmit={handleSubmit} initialValues={props.record}>
          {({ handleSubmit, values }) => (
            <form
              id="preview-quick-create"
              toolbar={null}
              record={values}
              onSubmit={handleSubmit}
            >
              {previewTypes && (
                <SelectInput
                  source="type"
                  choices={_map(previewTypes, (type) => ({
                    id: type,
                    name: type,
                  }))}
                />
              )}
              {withCustomLabel(values.type) && (
                <>
                  <TextInput
                    label="Preview Label"
                    source="label"
                    validate={validateLabel}
                  />
                </>
              )}
              <FileInput
                label="Preview Image"
                source="file"
                placeholder={<p>Drop your preview file here</p>}
                validate={validateFile}
              >
                <FileField source="url" title="title" target="_blank" />
              </FileInput>
            </form>
          )}
        </Form>
      </DialogContent>
      <DialogActions>
        <Button size="small" onClick={handleClose}>
          Cancel
        </Button>
        <SaveButton
          size="small"
          color="primary"
          handleSubmitWithRedirect={handleClick}
          label="Add preview"
        >
          Submit
        </SaveButton>
      </DialogActions>
    </Dialog>
  );
};

export default PreviewDialog;
